<template>
  <TopLoadingBar />
  <router-view :key="route.fullPath" />
</template>

<script setup>
import 'vue3-toastify/dist/index.css'
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { AppService } from '@/services/app.service'
import TokenService from '@/services/storage.service'
import TopLoadingBar from '@/components/TopLoadingBar.vue'

const store = useStore()
const route = useRoute()
const firstLoad = ref(true)

setInterval(() => {
  if (firstLoad.value) {
    firstLoad.value = false
  } else {
    window.location.reload(true)
  }
}, 3600000)

onMounted(async () => {
  const langs = TokenService.getLangs()

  if (!langs?.length) {
    const response = await AppService.tenantLanguages()
    TokenService.saveLangs(response?.data ?? [])
  }
})
</script>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
</style>
